<template>
  <v-app>
    <!-- Hero Section -->
    <v-container fluid class="hero-section primary" style="background: linear-gradient(135deg, #8D4E3C 0%, #6D4C41 100%);">
      <v-container>
        <v-row align="center" justify="center" class="py-8">
          <v-col cols="12" md="8" class="text-center">
            <v-icon size="64" color="white" class="mb-4">mdi-calendar-clock</v-icon>
            <h1 class="display-1 white--text font-weight-bold mb-3">
              Mis Turnos
            </h1>
            <p class="title white--text mb-4">
              Reserve su cita médica de forma rápida y sencilla
            </p>
            <v-chip color="white" class="primary--text" large>
              <v-icon left>mdi-phone</v-icon>
              Consultas: 291-407-1621
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <!-- Main Content -->
    <v-container class="py-8">
      <!-- Information Card -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-alert
            type="info"
            border="left"
            colored-border
            class="mb-4"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-3" color="info">mdi-information</v-icon>
              <div>
                <h4>Información Importante</h4>
                <p class="mb-0">
                  Puede consultar al número <strong>291-407-1621</strong> si el profesional con el que se desea atender trabaja con su obra social.
                </p>
              </div>
            </div>
          </v-alert>
        </v-col>
      </v-row>

      <!-- Doctor Selection -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card elevation="2" class="rounded-lg">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-doctor</v-icon>
              Seleccionar Profesional
            </v-card-title>
            <v-card-text class="pa-6">
              <v-select 
                v-model="selected"
                :items="nombres"
                label="Seleccione un médico"
                item-text="text"
                item-value="value"
                @change="refreshEvents"
                clearable
                :disabled="nombres.length === 0"
                return-object
              ></v-select>
              <div v-if="nombres.length === 0" class="text-center mt-2">
                <v-chip color="warning" small>
                  <v-icon left small>mdi-loading</v-icon>
                  Cargando profesionales...
                </v-chip>
              </div>
              <div v-else-if="nombres.length > 0" class="text-center mt-2">
                <v-chip color="success" small>
                  <v-icon left small>mdi-check</v-icon>
                  {{ nombres.length }} profesionales disponibles
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Message Display -->
      <v-row v-if="messege!==''" class="mb-6">
        <v-col cols="12">
          <v-alert
            type="warning"
            border="left"
            colored-border
          >
            <h4>{{ messege }}</h4>
          </v-alert>
        </v-col>
      </v-row>

      <!-- Appointments Table -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="2" class="rounded-lg">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-calendar-clock</v-icon>
              Turnos Disponibles
              <v-spacer></v-spacer>
              <v-chip v-if="selected" color="white" class="primary--text">
                {{ selectedText }}
              </v-chip>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="appointments"
                item-key="id"
                class="modern-table"
                :loading="loadding"
                hide-default-footer
                :server-items-length="totalRows"
                @click:row="confirmarTurnoLista($event)"
                :no-data-text="selected ? 'No hay turnos disponibles para este profesional' : 'Seleccione un médico para ver turnos disponibles'"
                loading-text="Cargando turnos disponibles..."
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    color="primary"
                    small
                    @click="confirmarTurnoLista(item)"
                    class="rounded-lg"
                  >
                    <v-icon left small>mdi-calendar-check</v-icon>
                    Reservar
                  </v-btn>
                </template>
                
                <template v-slot:item.start="{ item }">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" color="primary">mdi-calendar</v-icon>
                    {{ convertirFormatoDate(item.start) }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
//import { INITIAL_EVENTS, createEventId, profesionalNames } from './event-utils'

import { getProfesionales, decodeProfesional, getPacienteUnificado } from '@/services/monolito';
import { getTurnosDisponibles, reservarTurno, getTurnosCancelados } from '@/services/appointmentsApi';
import { convertDateFormat } from "@/services/utils"
import errorsMixin from '@/mixins/errorsMixin'

let utils = require('@/utils')
var dateFormat = require("dateformat")

export default {
  name: "calendar",
  mixins: [errorsMixin],
  components: {
  },
  
  data: function() {
    return {
      tab: null,
      items1: [
         'Calendario','Lista',
      ],
      loadding: false,
      totalRows: 0,
      headers : [
        {text:"Disponible", align:"center", sort: false, value:"start"},
        //{text:"Nombre", align:"center", sort: false, value:"nombre"},
        //{text:"Apellido", align:"center", sort: false, value:"lastname"},
        //{text:"Telefono y Obra Social", align:"center", sort: false, value:"title"},
        {text:"",align:"center", sort: false, value:"actions"},
        ],
      selected: null,
      professionalName: '',
      appointments: [],
      profesional: [],
      nombres: [],
      items:[],
      EXCLUDE_PROFESIONAL: ["NOELANI COLINAS", "CRISTINA MONTI", "NICOLAS DOSSO", "SILVINA DE PEDRO", "MARIA DE LOS ANGELES TERRAGNOLO"],
      DISCLAIMER_PROFESIONAL : ["SILVINA DE PEDRO"],
      turno: {
        profesional_name : '',
        start : '',
        end : '',
      },      
      messege:'',
      currentEvents: []
    }
  },
  created(){
    this.getProfesional()
  },
  mounted(){
    
        
  },
  computed: {
    selectedText() {
      if (!this.selected) return '';
      
      // Si selected es un objeto con text
      if (typeof this.selected === 'object' && this.selected.text) {
        return this.selected.text;
      }
      
      // Si selected es un valor, buscar en nombres
      const selectedValue = this.selected.value || this.selected.id || this.selected;
      const selectedProfesional = this.nombres.find(prof => prof.value === selectedValue);
      return selectedProfesional ? selectedProfesional.text : '';
    }
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.refreshEvents();
      }
    },
    nombres(newVal) {
    }
  },
  methods: {
    async checkPaciente(){
      
      // Si ya tiene teléfono en el store, todo ok
      if (this.$store.state.credentials.telefono && this.$store.state.credentials.telefono !== '') {
        return true;
      }
      
      // Si no, intentar buscar en el backend por si se actualizó y no refrescó
      const dni = this.$store.state.credentials.dni;
      if (dni) {
          try {
              const resultado = await getPacienteUnificado(dni);
              if (resultado.success && resultado.data) {
                  const data = resultado.data;
                  // Extraer contacto (similar a PacienteMixin)
                  let contacto = {};
                  if (Array.isArray(data)) {
                      // Estructura array: [paciente, direccion, contacto, usuario]
                      if (data[2]) contacto = data[2];
                  } else {
                       // Estructura objeto simple (unificado)
                       if (data.contacto) contacto = data.contacto;
                  }
                  
                  if (contacto && contacto.value) {
                       // Actualizar store para futuras validaciones
                       let credentials = { ...this.$store.state.credentials };
                       credentials.telefono = contacto.value;
                       this.$store.commit('set_credentials', credentials);
                       return true;
                  }
              }
          } catch (e) {
          }
      }
      
      return false;
    },
    async getProfesional() {
        try {
            this.profesional = await getProfesionales();
            
            if (this.profesional && this.profesional.length > 0) {
                this.nombres = decodeProfesional(this.profesional);
            } else {
                this.nombres = [];
            }
        } catch (error) {
            this.nombres = [];
        }
    },
    refreshEvents() {
      if (this.selected && (this.selected.value || this.selected.id)) {
        // Si selected es un objeto, usar value o id
        const selectedId = this.selected.value || this.selected.id || this.selected;
        this.getAppointments();
      } else if (this.selected && typeof this.selected === 'string') {
        // Si selected es un string directo
        this.getAppointments();
      } else {
        this.currentEvents = [];
        this.items = [];
      }
    },
    convertirFormatoDate(fecha) {
        return convertDateFormat(fecha);
    },
    async getAppointments() {
            this.loadding = true;
            
            // Normalizar el valor seleccionado para obtener el ID correcto
            let selectedId = null;
            let indice = -1;
            
            if (this.selected != null) {
                // Si selected es un objeto, extraer el value o id
                if (typeof this.selected === 'object') {
                    selectedId = this.selected.value || this.selected.id || this.selected;
                } else {
                    selectedId = this.selected;
                }
                
                // Buscar el índice usando el ID correcto
                indice = this.nombres.findIndex(function(profesional) {
                    return profesional.value === selectedId || profesional.id === selectedId;
                });
                
                if (indice === -1) {
                    this.loadding = false;
                    return;
                }
        
                // Usar el nombre formateado del array nombres (igual que CitasPublico)
                let profesionalName = this.nombres[indice].text || '';
                if (typeof profesionalName === 'string') {
                    profesionalName = profesionalName.toUpperCase();
                } else {
                    profesionalName = '';
                }
                
                // Usar .some() con .includes() para búsqueda más flexible (igual que CitasPublico)
                if (this.EXCLUDE_PROFESIONAL.some(excluded => profesionalName.includes(excluded))) {
                    this.messege = "IMPORTANTE: Si usted quiere atenderse con " + profesionalName + ", no saque turno por aqui. Comuniquese por telefono por favor. Gracias"
                    this.appointments = [];
                    this.totalRows = 0;
                    this.loadding = false;
                    return;
                }
                else if (this.DISCLAIMER_PROFESIONAL.some(disclaimer => profesionalName.includes(disclaimer))){
                    this.messege = "IMPORTANTE: El/La doctor/a " + profesionalName + ", no toma nuevos pacientes. Gracias por comprender."
                }
                else{
                    this.messege = ''
                }
            }
            
            try {
                // Usar el nuevo API unificado
                const turnosDisponibles = await getTurnosDisponibles(selectedId);
                
                // Fetch cancelled turns explicitly forcing Unified Endpoint
                const turnosCancelados = await getTurnosCancelados(selectedId);
                
                // Merge and sort
                let allAppointments = [...turnosDisponibles, ...turnosCancelados];

                // Deduplicate by ID
                allAppointments = Array.from(new Map(allAppointments.map(item => [item.id, item])).values());
                
                // Sort by start date
                allAppointments.sort((a, b) => {
                    return new Date(a.start) - new Date(b.start);
                });
                
                this.appointments = allAppointments;
                this.totalRows = this.appointments.length;
            } catch (error) {
                this.appointments = [];
                this.totalRows = 0;
            }
            
            this.loadding = false;
    },
    
    async confirmarTurno(event) {
      if (await this.checkPaciente()) {
        const dni = this.$store.state.credentials.dni;
        const result = await reservarTurno(event.id, dni);
 
        if (result.success) {
          let indice = this.nombres.findIndex(function(profesional) {
              return profesional.value === this.selected.value;
          }.bind(this));
          
          this.turno.profesional_name = this.profesional[indice].party.name + " " + this.profesional[indice].party.lastname;
          this.turno.especialidad = utils.traducir(this.profesional[indice].specialty.name);
          
          this.turno.start = new Date(event.start.toLocaleString("es-AR"));
          this.turno.end = new Date(event.end.toLocaleString("es-AR"));
         
          this.$store.commit('set_turno', this.turno);
          this.$router.replace({ name: "turno" });
        }
        else if (result.status === 423) {
          this.$alert({ title: 'Turno duplicado', message: 'Usted ya tiene un turno reservado para el mismo día con este médico. Cualquier duda contáctese vía telefónica.', color: 'warning' });
        }
        else {
          this.$alert({ title: 'No se pudo registrar', message: 'Hubo un problema al registrar su turno. Contáctese vía telefónica.', color: 'error' });
        }
      }
      else {
        await this.$alert({ title: 'Datos personales', message: 'Usted no tiene los datos personales actualizados. Por favor, vaya a la sección CUENTA y actualícelo.', color: 'warning' });
        this.$router.replace({ name: "cuenta" });
      }
    },
    
    async confirmarTurnoLista(event) {
      if (await this.$confirm({ title: 'Confirmar', message: '¿Esta seguro que desea reservar este turno?' })) {
        this.confirmarTurno(event);
      }
    }
  }  
}
</script>

<style lang='css'>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__search,
.style-chooser .vs__selected,
.style-chooser .vs__dropdown-menu {
  background: #ffffff;
  border: none;
  text-transform: uppercase;
  font-variant: small-caps;
  text-align: center;
}
.style-chooser .vs__fade-enter-active,
.style-chooser .vs__fade-leave-active {
  transition: none;
}
.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
} 
@media screen and (max-width: 500px){
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__search,
  .style-chooser .vs__selected,
  .style-chooser .vs__dropdown-menu {
    border: none;
    text-transform: uppercase;
    font-variant: small-caps;
    text-align: center;
    font-size: 10px;
  }
}
ul {
  margin: 0;
  padding: 0 0 0 1.5pm;
}
li {
  margin: 0 1pm;
  padding: 0;
  list-style: none;
}
b { /* used for event dates/times */
  margin-right: 3px;
}
.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}

@media screen and (max-width: 500px){
    #nav ul li{
        float: center;
    }
    .ghbutton {
        text-transform: uppercase;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 11px;
    }
}
</style>

<style scoped>
/* Hero Section Styles */
.hero-section {
  min-height: 300px;
}

/* Modern Card Styles */
.rounded-lg {
  border-radius: 12px !important;
}

.v-card {
  overflow: hidden;
}

.v-card-title {
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Modern Table Styles */
.modern-table {
  border-radius: 0 0 12px 12px;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 0 12px 12px;
}

/* Doctor Select Styles */
.doctor-select >>> .v-input__control {
  border-radius: 8px;
}

/* Primary Color Theme */
.primary {
  background-color: #8D4E3C !important;
}

.primary--text {
  color: #8D4E3C !important;
}

/* Enhanced Alert Styles */
.v-alert {
  border-radius: 8px !important;
}

/* Button Styles */
.v-btn.rounded-lg {
  border-radius: 8px !important;
  text-transform: none;
  font-weight: 500;
}

/* Chip Styles */
.v-chip {
  font-weight: 500;
}

/* Icon Spacing */
.v-icon {
  margin-right: 8px;
}

/* Legacy styles for compatibility */
.demo-app-event {
    border-radius: 3px;
    font-size: 11px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: white;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 11px;
}
.ghbutton {
    text-transform: uppercase;
}

@media screen and (max-width: 500px){
  .demo-app{
          /* Reverse the axis of the header, making it vertical. */
          
          /* Align items to the begining (the left) of the header. */
          align-items: center;
          font-size: 12px;
  }
  
}
@media screen and (max-width: 500px) {
  .container{
    font-size: 10px;
  }
}

.demo-app-sidebar {

  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}
.demo-app-sidebar-section {
  padding: 2em;
}
.demo-app-main {
  flex-grow: 1;
  padding-top: 0em;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 1em;
  
}
.fc { /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
.filter-row {
    background-color: #00acc6;
    padding-top: 1em;
    padding-bottom: 1em;
    /*margin-bottom: 50px;*/
}
</style>